import React from 'react';
import TextFilter from 'components/list/Filters/types/TextFilter';

const LicensePlateFilter = <TextFilter
    label='filters.components.licensePlate.label'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='license_plate'
/>;

export default LicensePlateFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/LicensePlateFilter.js